// extracted by mini-css-extract-plugin
module.exports =  {"LandingFAQ":"B5tGv76O","heading":"gK6wnbTT","list":"JNjmZYgV"};